import React, { useEffect, useState } from 'react'
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { inactivarActivarBeneficioAPI, getItemsAPI } from '../../../consumers/backendApisUrls';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import ModalEnabled from '../../../components/modalComponents/ModalEnabled';
import PageHeader from '../../../components/pageHeader/PageHeader';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import PaginatorV2 from '../../../components/pageComponents/PaginatorV2';
import PageButtons from '../../../components/pageComponents/PageButtons';
import CrearItem from './modales/CrearItem';
import EditarItem from './modales/EditarItem';
import ActionGenericModal from '../../../components/modal/ActionGenericModal';
import TableItems from './TableItems';

const GestionDeItems = () => {
  const [formValues, setFormValues] = useState({
    Items: [],
    ExtraData: {},
    filters: [],
    selectedFilters: {},
  });

  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);

  const [modalEnabled, setModalEnabled] = useState({
    isEnable: false,
    component: React.Fragment,
  });

  const [executeManagePost] = useManagePostRequest();

  const init = async () => {
    setIsLoading(true);
    try {
      await manageSearch();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const manageSearch = async () => {
    setIsLoading(true);
    const api = getItemsAPI();
    const payload = getPayload();
    try {
      await executeManagePost(api, payload, successManageSearchCallback);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCleanSearch = () => {
    setFormValues({ ...formValues, selectedFilters: null });
  };

  const getPayload = () => {
    return {
      Criteria: searchCriteria,
      Page: paginator.CurrentPage,
      ...formValues.selectedFilters,
    };
  };

  const successManageSearchCallback = ({ data }) => {
    const {
      Items,
      ExtraData,
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    } = data;
    const updatedItems = Items.map((o) => {
      const { IdPlantillaCuponTiempoLibre, ImagenCuponTiempoLibreURL } = o;
      return {
        ...o,
        Id: IdPlantillaCuponTiempoLibre,
        ImagenUrl: ImagenCuponTiempoLibreURL,
      };
    });
    setFormValues((lastData) => ({
      ...lastData,
      Items: updatedItems,
      ExtraData,
    }));
    setPaginator({
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    });
  };

  const handleEditBeneficio = (row) => {
    setModalEnabled({
      isEnable: true,
      component: EditarItem,
      data: { IdBeneficioItem: row.IdBeneficioItem },
    });
  };

  const handleActiveInactiveBeneficio = (row) => {
    const api = inactivarActivarBeneficioAPI;
    setModalEnabled({
      isEnable: true,
      component: ActionGenericModal,
      data: {
        title: row.EsActivo ? "Inactivar" : "Activar",
        actionLabel: row.EsActivo ? "Inactivar" : "Activar",
        api,
        name: row.Descripcion,
        id: row.IdBeneficioItem,
      },
    });
  }
  
  useEffect(() => {
    init();
  }, [])

  return (
    <PageWrapper isLoading={isLoading}>
      <ModalEnabled
        modalEnabled={modalEnabled}
        setModalEnabled={setModalEnabled}
        refreshPage={manageSearch}
      />
      <PageHeader title="Gestión de beneficios" />
      <SearchContainer
        searchCriteria={searchCriteria}
        setSearchCriteria={setSearchCriteria}
        setPaginator={setPaginator}
        manageSearch={manageSearch}
        addCleanSearch={handleCleanSearch}>
        <PageButtons
          hasBackButton
          hasCreateButton
          handleCreateButton={() =>
            setModalEnabled({ isEnable: true, component: CrearItem })
          }
        />
      </SearchContainer>
      <TableItems
        rows={formValues.Items}
        handleEditBeneficio={handleEditBeneficio}
        handleActiveInactiveBeneficio={handleActiveInactiveBeneficio}
        isFetching={isLoading}
      />
      <div className="px-5 mb-4">
        <PaginatorV2
          paginator={paginator}
          setPaginator={setPaginator}
          manageSearch={manageSearch}
        />
      </div>
    </PageWrapper>
  );
};

export default GestionDeItems;